import { useColorModeValue } from '@chakra-ui/color-mode';
import { Image } from '@chakra-ui/image';
import { Box, Center, Link, SimpleGrid, Text, VStack } from '@chakra-ui/layout';
import { motion } from 'framer-motion';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { SOCIAL_LINKS } from '../utils/constants';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Card = ({ username, icon }) => {
	AOS.init({
		offset: 50
	});

	return (
		<VStack
			maxWidth='200px'
			maxHeight='200px'
			background={useColorModeValue('gray.200', 'gray.600')}
			p={5}
			borderRadius='2xl'
			boxShadow='sm'
		>
			<Image
				width='50px'
				height='40px'
				src={`/images/${icon}`}
				alt={icon}
				loading='lazy'
			/>
			<Text>{username}</Text>
		</VStack>
	);
};

const Contact = () => {
	useDocumentTitle();
	AOS.init();
	return (
		<Box
			minHeight={{ md: 'calc(100vh - 120px)' }}
			background={useColorModeValue('gray.50', 'gray.800')}
			pl={9}
			pr={9}
			my={{ base: 10, md: 0 }}
			pt={10}
		>
			<div data-aos="fade-down" data-aos-anchor-easing='ease-in-out' data-aos-anchor-placement="top-center" paddingLeft={9} paddingRight={9}>
				<Center>
					<VStack>
						<Text
							display='inline'
							borderBottomColor='red.500'
							borderBottomWidth='2px'
							borderBottomRadius='2px'
							mb={10}
						>
							Contact me
						</Text>
						<Text>
							Message me on any of these platforms to get in contact with me.
						</Text>
						<SimpleGrid
							spacing={{ base: '5', md: '8' }}
							columns={{ base: 1, sm: 2, md: 4 }}
						>
							{SOCIAL_LINKS.map((social) => (
								<Link
									href={social.link}
									key={social.icon}
									target='_blank'
									ml='1rem !important'
									mb='1rem !important'
								>
									<motion.div whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}>
										<Card {...social} />
									</motion.div>
								</Link>
							))}
						</SimpleGrid>
					</VStack>
				</Center>
			</div>
		</Box>
	);
};

export default Contact;
